export default function shouldUseGrid(menuItem, category) {
    return menuItem === category;
}
